import { render } from "./FooterOfPage.vue?vue&type=template&id=07d051bd"
const script = {}

import exportComponent from "C:\\Users\\1367862\\WebstormProjects\\argon\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__